import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import { useTranslation } from "react-i18next";
export const DrawerInfoQuestionsForm = ({ open, onClose, title, description }) => {
    const { t } = useTranslation();
    return (_jsx(Drawer, Object.assign({ className: "drawer-help-form-questions", anchor: "left", open: open, onClose: onClose, container: document.body, ModalProps: {
            keepMounted: true,
            sx: {
                zIndex: 999999999,
            },
        }, PaperProps: {
            sx: {
                width: {
                    xs: '100%',
                    sm: 600 // Escritorio desde 600px
                },
            },
        } }, { children: _jsxs(Box, Object.assign({ sx: { p: 2, display: "flex", flexDirection: "column", height: "100%" } }, { children: [_jsxs(Box, Object.assign({ display: "flex", justifyContent: "space-between", alignItems: "start" }, { children: [_jsx("h1", { children: title || "Información" }), _jsx(IconButton, Object.assign({ onClick: onClose }, { children: _jsx(CloseIcon, {}) }))] })), _jsx(Box, Object.assign({ mt: 2, flexGrow: 1 }, { children: open && _jsx("div", { dangerouslySetInnerHTML: { __html: description } }) })), _jsx("div", Object.assign({ className: "drawer-help-form-questions_botonera" }, { children: _jsx(Button, Object.assign({ onClick: onClose, "aria-label": t('common.btn.close'), "data-testid": "close-icon-button", variant: "contained", sx: {
                            width: {
                                xs: '100%',
                                sm: 'auto',
                            },
                            minWidth: {
                                sm: '130px',
                            },
                        } }, { children: t('common.btn.close') })) }))] })) })));
};
